<script>
  import moment from "moment";
  import { onMount, createEventDispatcher } from "svelte";
  import { fade, slide} from "svelte/transition";

  import { navigate, Link } from "svelte-routing";
  import { apiCall, apiGet, apiUpdate, apiCreate, notify } from "../httpCommon";
  import Paper, { Title, Content } from "@smui/paper";
  import Card from "@smui/card";
  import Button, { Label, Icon } from "@smui/button";

  export let resource;
  export let id;
  export let title = "";
  export let data = null;
  export let topLevel = true;
  export let errors = {};
  export let loading = false;

  const dispatch = createEventDispatcher();

  const basePath = `/${resource}`;

  $: [surface, sfcProps, classname] = topLevel
    ? [Paper, { elevation: 5, class: "top-level" }, 'top-level']
    : [Card, { variant: "outlined", padded: true }, ''];

  let invalid = {};

  $: isCreate = id === "create";

  async function load() {
    try {
      loading = true;
      data = await apiGet(basePath, id);
      dispatch("loaded", data);
    } catch (error) {
    } finally {
      loading = false;
    }
  }

  async function save() {
    errors = {};
    try {
      loading = true;
      if (isCreate) {
        data = await apiCreate(basePath, data);
        id = data.id;
        dispatch("created", data);
      } else {
        data = await apiUpdate(basePath, id, data);
        dispatch("updated", data);
      }
    } catch (error) {
      errors = error.errors;
      if (errors) {
        console.log("errors: ", errors);
      }
    } finally {
      loading = false;
    }
  }

  async function close() {
    navigate(basePath);
  }

  onMount(() => {
    console.log(
      `ResourceShow ${resource}, isCreate: ${isCreate} data is set: ${!!data}`
    );
    if (!isCreate && !data) {
      load();
    } else if (!data) {
      data = {};
    }
  });
</script>

<style>
  .outer {
    position: relative;
    min-height: 100px;
  }

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    z-index: 5;
    opacity: 0.4;
    transition: opacity 0.5s;
    background: lightgrey;
    justify-content: center;
    align-items: center;
  }

  .overlay span {
    z-index: 8;
    text-align: center;
  }
</style>

<svelte:component this={surface} {...sfcProps} class="{classname}">
  <slot name="title" {load} {save} {close} {loading}>
    <Title>
      <div class="flex">
        <span class="title">{title}</span>
        <span>
          {#if isCreate}
            <Button on:click={save} disabled={loading}>
              <Icon class="material-icons">save</Icon>
              <Label>save</Label>
            </Button>
          {:else}
            <Button on:click={load} disabled={loading}>
              <Icon class="material-icons">replay</Icon>
              <Label>Reload</Label>
            </Button>
            <Button on:click={save} disabled={loading}>
              <Icon class="material-icons">save</Icon>
              <Label>save</Label>
            </Button>
          {/if}
          <Button on:click={close} disabled={loading}>
            <Icon class="material-icons">cancel</Icon>
            <Label>close</Label>
          </Button>
        </span>
      </div>
    </Title>
  </slot>
  <Content>
    <div class="outer">
      {#if loading}
        <div in:fade|local={{ delay: 500, duration: 500 }} out:fade|local class="overlay">
          <span>Loading</span>
        </div>
      {/if}
      <slot name="content" {load} {save} {close}  />
    </div>
  </Content>
</svelte:component>
